(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[57457,12495],{

/***/ 319326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme }) => [
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F,
  `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
`
]);
const CardHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const CardBody = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const CardFooter = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const Card = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, { children, header, footer, className } = _b, props = __objRest(_b, ["children", "header", "footer", "className"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, __spreadValues({
    className: (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeCls */ .c8)("teko-card", className || ""),
    ref
  }, props), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardHeader, {
    className: "teko-card-header"
  }, header), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardBody, {
    className: "teko-card-body"
  }, children), footer && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardFooter, {
    className: "teko-card-footer"
  }, footer));
});
Card.displayName = "Card";




/***/ }),

/***/ 512495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ FavouriteAlternativeOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FavouriteAlternativeOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.6362 5.75C16.6307 5.75 17.5345 6.15409 18.1899 6.80453C18.8431 7.45286 19.25 8.34674 19.25 9.33095C19.25 12.4832 14.6986 16.7712 12.6212 18.6318C12.444 18.7906 12.2221 18.8704 11.9999 18.8704C11.7775 18.8704 11.5553 18.7904 11.3778 18.6316C9.30052 16.7712 4.75 12.4832 4.75 9.33095C4.75 8.34674 5.15687 7.45286 5.81012 6.80453C6.46549 6.15409 7.36934 5.75 8.36379 5.75C9.63426 5.75 10.7192 6.417 11.3835 7.3758C11.6822 7.80686 11.8958 8.29678 12 8.8134C12.1041 8.29665 12.3178 7.80686 12.6165 7.3758C13.2808 6.417 14.365 5.75 15.6362 5.75Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 791990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ EmptyState; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/i18n.es.js
var i18n_es = __webpack_require__(334751);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(179185);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/EmptyState/search-no-result.es.js
var emptyImage = "https://shopfront-cdn.tekoapis.com/static/e536f0592aa3c8b1.png";



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/Flex/Flex.es.js
var Flex_es = __webpack_require__(112288);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/Text/Text.es.js
var Text_es = __webpack_require__(327513);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/EmptyState/EmptyState.es.js







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EmptyState = (_a) => {
  var _b = _a, {
    text
  } = _b, props = __objRest(_b, [
    "text"
  ]);
  return /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, __spreadProps(__spreadValues({}, props), {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }), /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
    height: 128,
    width: 128,
    src: emptyImage
  }), /* @__PURE__ */ react.createElement(Text_es/* Text */.x, {
    fontSize: 12,
    color: "#848788",
    marginTop: "24px",
    paddingX: "2rem"
  }, text || (0,i18n_es.t)("Kh\xF4ng t\xECm th\u1EA5y d\u1EEF li\u1EC7u")));
};




/***/ }),

/***/ 112288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Flex; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, (props) => `
  display: flex;
  ${props.justifyContent ? `justify-content: ${props.justifyContent};` : ""}
  ${props.alignItems ? `align-items: ${props.alignItems};` : ""}
  ${props.flexDirection ? `flex-direction: ${props.flexDirection};` : ""}
`);
const Flex = (_a) => {
  var _b = _a, {
    children,
    onClick
  } = _b, props = __objRest(_b, [
    "children",
    "onClick"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    onClick: () => {
      if (onClick)
        onClick();
    }
  }, props), children);
};




/***/ }),

/***/ 358277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Container = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(styled_system__WEBPACK_IMPORTED_MODULE_0__.space, ({ fluid }) => {
  const styles = {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: "1rem",
    paddingRight: "1rem"
  };
  if (!fluid) {
    styles.maxWidth = "1264px";
  }
  return styles;
});




/***/ }),

/***/ 179185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; },
/* harmony export */   "x": function() { return /* binding */ WebpImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => ({
  maxWidth: "100%",
  position: "relative",
  overflow: "hidden",
  flex: "1 0 auto",
  display: "flex",
  cursor: props.onClick ? "pointer" : "unset",
  zIndex: 0,
  margin: "auto",
  borderRadius: props.borderRadius + "px",
  paddingBottom: props.height ? "" : `${100 / props.aspectRatio}%`,
  border: props.border ? "1px solid #e0e0e0" : "",
  height: props.height ? `${props.height}px !important` : "",
  width: props.width ? `${props.width}px` : "100%",
  backgroundImage: props.thumbnail ? `url("${props.thumbnail}")` : null,
  backgroundSize: props.thumbnail ? "cover" : null,
  contentVisibility: props.height && props.width ? "auto" : null
}));
const WebpImage = ({
  src,
  onClick,
  className,
  height,
  width,
  imageWidth,
  alt = "",
  decoding = "async",
  onLoad
}) => {
  const placeHolder = "data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
  let imageUrl = src ? src : placeHolder;
  let altImageUrl = null;
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    if (imageWidth || width) {
      imageUrl = `${imageUrl}=w${imageWidth || width}`;
    }
    const checkExt = /=[a-z0-9-]+$/;
    altImageUrl = imageUrl;
    imageUrl = `${imageUrl}${checkExt.test(imageUrl) ? "-rw" : "=rw"}`;
  }
  const imgError = (event) => {
    if (event.target.src !== placeHolder) {
      event.target.src = placeHolder;
    }
    return;
  };
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width,
    height,
    onClick,
    className,
    alt,
    onError: imgError,
    src: imageUrl,
    loading: "lazy",
    decoding,
    onLoad
  });
  return altImageUrl ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: imageUrl,
    type: "image/webp"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: altImageUrl,
    type: "image/png"
  }), imgEle) : imgEle;
};
const WrapperImage = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WebpImage)((props) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${props.contain ? "contain" : props.cover ? "cover" : ""};
  transition: transform 0.5s;
  &:hover {
    transform: ${props.hover === "zoom" ? "scale(1.05)" : ""};
  }
  `);
const LazyImage = ({
  src,
  onClick,
  className,
  contain = false,
  cover = false,
  aspectRatio = 1,
  height,
  width,
  alt = "",
  border = false,
  hover = "",
  borderRadius = 0,
  thumbnail,
  decoding = "async",
  imageWidth
}) => {
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperImage, {
    hover,
    className: "lazyload",
    contain,
    imageWidth,
    cover,
    alt,
    "data-src": src,
    src,
    decoding
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height,
    width,
    border,
    aspectRatio,
    borderRadius,
    onClick,
    className,
    thumbnail
  }, imgEle);
};




/***/ }),

/***/ 433778:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/notification",
      function () {
        return __webpack_require__(730492);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 429491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ AccountLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(423942);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(358277);
/* harmony import */ var helpers_navigation_bar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(382934);
/* harmony import */ var hooks_useLoyaltyMemberInfo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(401192);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var reflexbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(504545);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(684443);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  padding-right: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  min-height: 77vh;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










const SideNav = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>Promise.all(/* import() */[__webpack_require__.e(54615), __webpack_require__.e(98590), __webpack_require__.e(57616), __webpack_require__.e(8278), __webpack_require__.e(59855), __webpack_require__.e(96713)]).then(__webpack_require__.bind(__webpack_require__, 659855)).then((mod)=>mod.SideNav), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(659855)
            ]
    }
});
const UserCard = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>Promise.all(/* import() */[__webpack_require__.e(54615), __webpack_require__.e(98590), __webpack_require__.e(57616), __webpack_require__.e(8278), __webpack_require__.e(59855), __webpack_require__.e(96713)]).then(__webpack_require__.bind(__webpack_require__, 659855)).then((mod)=>mod.UserCard), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(659855)
            ]
    }
});
const SideBar = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.div */ .z.div(_templateObject());
const StyledContainer = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W)(_templateObject1());
const AccountLayout = (param)=>{
    let { children , hiddenUserNavItems  } = param;
    const { user  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_7__/* .useAuth */ .aC)();
    const { tenant , notificationAppId , epicOmni948 , epicOmni1538 , notFetchLoyaltyMemberInfoGlobally , displayNewLayout ,  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_8__/* .useTenantConfig */ .Wx)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { loyaltyMemberInfo  } = (0,hooks_useLoyaltyMemberInfo__WEBPACK_IMPORTED_MODULE_9__/* .useLoyaltyMemberInfo */ .h)(notFetchLoyaltyMemberInfoGlobally);
    const navItems = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        return (0,helpers_navigation_bar__WEBPACK_IMPORTED_MODULE_10__/* .getNavItems */ .r)({
            tenant,
            logged: !!(user === null || user === void 0 ? void 0 : user.userId),
            showLoyaltyItem: (notFetchLoyaltyMemberInfoGlobally ? !!(user === null || user === void 0 ? void 0 : user.loyaltyMemberId) : !!loyaltyMemberInfo) || !!epicOmni1538,
            showNotificationItem: !!notificationAppId,
            epicOmni948,
            epicOmni1546: true,
            displayNewLayout: displayNewLayout
        });
    }, [
        tenant,
        user,
        loyaltyMemberInfo,
        epicOmni1538,
        epicOmni948
    ]);
    // get all hrefs from navItems array above
    const flattedHrefs = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        return navItems.flatMap((navItem)=>{
            var ref;
            if (!!((ref = navItem.children) === null || ref === void 0 ? void 0 : ref.length)) {
                // not return href of navItem with children since it's not a screen anymore
                return [
                    ...navItem.children.map((item)=>{
                        return item.href;
                    }), 
                ];
            }
            return navItem.href;
        });
    }, [
        navItems
    ]);
    // sometimes asPath from router will have multiple queries --> this will affect active menu highlight
    // find the correct href by comparing with hrefs in navItems
    const mapAsPathToActiveHref = (asPath)=>{
        const correctHref = flattedHrefs.find((href)=>asPath === href);
        return !!correctHref ? correctHref : asPath;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledContainer, {
        mb: 3,
        mt: 3,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
            flexWrap: "wrap",
            children: [
                !hiddenUserNavItems && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                    width: [
                        1,
                        1 / 3,
                        1 / 5
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SideBar, {
                        children: [
                            !!(user === null || user === void 0 ? void 0 : user.userId) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserCard, {
                                name: (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.telephone) || "",
                                picture: (user === null || user === void 0 ? void 0 : user.avatar) || ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SideNav, {
                                activeHref: mapAsPathToActiveHref(router.asPath) || router.pathname,
                                navItems: navItems,
                                // disable parent menu highlight when it has children & epic omni 948 is enabled
                                parentMenuHighlight: !epicOmni948
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                    width: hiddenUserNavItems ? [
                        1
                    ] : [
                        1,
                        2 / 3,
                        4 / 5
                    ],
                    children: children
                })
            ]
        })
    });
};


/***/ }),

/***/ 235904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; },
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80912);




const Loading = (param)=>{
    let { isLoading , children  } = param;
    var ref;
    const { logo  } = (0,_contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
        isLoading: isLoading,
        logo: (ref = (logo === null || logo === void 0 ? void 0 : logo.loading) || (logo === null || logo === void 0 ? void 0 : logo.lite)) === null || ref === void 0 ? void 0 : ref.path,
        children: children
    });
};
const PreLoad = (param)=>{
    let { isLoading , height  } = param;
    var ref;
    const { logo  } = (0,_contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
        isLoading: isLoading,
        style: {
            height: typeof height === "number" ? "".concat(height, "px") : height
        },
        logo: (ref = (logo === null || logo === void 0 ? void 0 : logo.loading) || (logo === null || logo === void 0 ? void 0 : logo.lite)) === null || ref === void 0 ? void 0 : ref.path
    });
};


/***/ }),

/***/ 193275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BG": function() { return /* binding */ SHARED_NAV_ITEMS_TEXTS; },
/* harmony export */   "iu": function() { return /* binding */ SHARED_NAV_ITEMS; },
/* harmony export */   "m7": function() { return /* binding */ NEW_LAYOUT_NAV_ITEMS; },
/* harmony export */   "yh": function() { return /* binding */ SHARED_NAV_ITEMS_HREFS; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(749450);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883594);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(512495);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(402374);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(322312);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(234231);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71856);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(246263);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(476763);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(650896);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(192323);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(458538);


const SHARED_NAV_ITEMS_TEXTS = {
    ACCOUNT_INFORMATION: "Th\xf4ng tin t\xe0i khoản",
    ORDER_MANAGEMENT: "Quản l\xfd đơn h\xe0ng",
    WISH_LIST: "Sản phẩm y\xeau th\xedch",
    ADDRESS_BOOK: "Sổ địa chỉ",
    NOTIFICATION: "Th\xf4ng b\xe1o",
    PROMOTION_AND_UPDATE_NOTI: "Ưu đ\xe3i & Cập nhật",
    ORDERS_NOTI: "Đơn h\xe0ng",
    LOYALTY_HISTORY: "Điểm th\xe0nh vi\xean"
};
const SHARED_NAV_ITEMS_HREFS = {
    ACCOUNT_INFORMATION: "/account",
    ORDER_MANAGEMENT: "/account/orders",
    WISH_LIST: "/account/wish-list",
    ADDRESS_BOOK: "/account/addresses",
    NOTIFICATION: "/notification",
    PROMOTION_AND_UPDATE_NOTI: "/notification?type=promotion-and-update",
    ORDERS_NOTI: "/notification?type=orders",
    LOYALTY_HISTORY: "/my/loyalty-history"
};
const SHARED_NAV_ITEMS = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_1__/* .AccountOutlined */ .y, {
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.ACCOUNT_INFORMATION,
        href: SHARED_NAV_ITEMS_HREFS.ACCOUNT_INFORMATION,
        contentName: "viewAccountInfo",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__/* .OrderOutlined */ .y, {
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.ORDER_MANAGEMENT,
        href: SHARED_NAV_ITEMS_HREFS.ORDER_MANAGEMENT,
        contentName: "viewOrder",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .FavouriteAlternativeOutlined */ .w, {
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.WISH_LIST,
        href: SHARED_NAV_ITEMS_HREFS.WISH_LIST,
        contentName: "viewWishList",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .LocationOutlined */ .f, {
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.ADDRESS_BOOK,
        href: SHARED_NAV_ITEMS_HREFS.ADDRESS_BOOK,
        contentName: "viewAddressList",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .NotificationsOutlined */ .Z, {
            size: 18,
            className: "noti"
        }),
        text: SHARED_NAV_ITEMS_TEXTS.NOTIFICATION,
        href: SHARED_NAV_ITEMS_HREFS.NOTIFICATION,
        anonymous: true,
        showByConfiguration: true,
        contentName: "viewNotification",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .UnionPaymentOutlined */ .I, {
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.LOYALTY_HISTORY,
        href: SHARED_NAV_ITEMS_HREFS.LOYALTY_HISTORY,
        contentName: "viewLoyalty",
        regionName: "headerBar"
    }, 
];
const NEW_LAYOUT_NAV_ITEMS = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .AnonymousUserProfileOutlined */ .u, {
            color: "black",
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.ACCOUNT_INFORMATION,
        href: SHARED_NAV_ITEMS_HREFS.ACCOUNT_INFORMATION,
        contentName: "viewAccountInfo",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__/* .CubeOutlined */ .$, {
            color: "black",
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.ORDER_MANAGEMENT,
        href: SHARED_NAV_ITEMS_HREFS.ORDER_MANAGEMENT,
        contentName: "viewOrder",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__/* .HeartOutlined */ .F, {
            color: "black",
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.WISH_LIST,
        href: SHARED_NAV_ITEMS_HREFS.WISH_LIST,
        contentName: "viewWishList",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__/* .LocationPickerColored */ .B, {
            color: "black",
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.ADDRESS_BOOK,
        href: SHARED_NAV_ITEMS_HREFS.ADDRESS_BOOK,
        contentName: "viewAddressList",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__/* .BellOutlined */ .F, {
            color: "black",
            size: 18,
            className: "noti"
        }),
        text: SHARED_NAV_ITEMS_TEXTS.NOTIFICATION,
        href: SHARED_NAV_ITEMS_HREFS.NOTIFICATION,
        anonymous: true,
        showByConfiguration: true,
        contentName: "viewNotification",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .CopyrightColored */ .p, {
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.LOYALTY_HISTORY,
        href: SHARED_NAV_ITEMS_HREFS.LOYALTY_HISTORY,
        contentName: "viewLoyalty",
        regionName: "headerBar"
    }, 
];


/***/ }),

/***/ 382934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ getNavItems; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(193275);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(634655);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const getNavItems = (config)=>{
    const { logged , showLoyaltyItem , showNotificationItem , epicOmni948 , epicOmni1546 , displayNewLayout ,  } = config;
    let _navItems = displayNewLayout ? _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .NEW_LAYOUT_NAV_ITEMS */ .m7 : _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS */ .iu;
    if (!logged) {
        _navItems = _navItems.filter((nav)=>nav.anonymous);
    }
    if (logged && !showLoyaltyItem) {
        _navItems = _navItems.filter((nav)=>nav.contentName != "viewLoyalty");
    }
    if (logged && !epicOmni1546) {
        _navItems = _navItems.filter((nav)=>nav.contentName != "viewWishList");
    }
    if (epicOmni948) {
        // find index of notification menu in navItems
        const notiItemIndex = _navItems.findIndex((navItem)=>navItem.text === _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_TEXTS.NOTIFICATION */ .BG.NOTIFICATION);
        // check if notification menu exists in navItems (if true, index return will >= 0)
        if (notiItemIndex >= 0) {
            // modify href of notification menu to point to promotion & update notification screen.
            // add new menus as children: promotion & update and orders.
            const newNotiItem = _objectSpreadProps(_objectSpread({}, _navItems[notiItemIndex]), {
                href: _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_HREFS.PROMOTION_AND_UPDATE_NOTI */ .yh.PROMOTION_AND_UPDATE_NOTI,
                children: [
                    {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                width: "18px",
                                height: "18px"
                            }
                        }),
                        text: _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_TEXTS.PROMOTION_AND_UPDATE_NOTI */ .BG.PROMOTION_AND_UPDATE_NOTI,
                        href: _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_HREFS.PROMOTION_AND_UPDATE_NOTI */ .yh.PROMOTION_AND_UPDATE_NOTI,
                        fallbackHref: _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_HREFS.NOTIFICATION */ .yh.NOTIFICATION,
                        anonymous: true,
                        showByConfiguration: true,
                        contentName: "viewPromotionAndUpdateNotification",
                        regionName: "headerBar"
                    },
                    {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                width: "18px",
                                height: "18px"
                            }
                        }),
                        text: _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_TEXTS.ORDERS_NOTI */ .BG.ORDERS_NOTI,
                        href: _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_HREFS.ORDERS_NOTI */ .yh.ORDERS_NOTI,
                        anonymous: true,
                        showByConfiguration: true,
                        contentName: "viewOrdersNotification",
                        regionName: "headerBar"
                    }, 
                ]
            });
            _navItems[notiItemIndex] = newNotiItem;
        }
    }
    return _navItems.filter((nav)=>!nav.showByConfiguration || nav.showByConfiguration && showNotificationItem).map((item)=>{
        return !!item.children && !!item.children.length ? _objectSpreadProps(_objectSpread({}, item), {
            text: (0,_i18n__WEBPACK_IMPORTED_MODULE_2__.t)(item.text),
            children: item.children.map((childrenItem)=>_objectSpreadProps(_objectSpread({}, childrenItem), {
                    text: (0,_i18n__WEBPACK_IMPORTED_MODULE_2__.t)(childrenItem.text)
                }))
        }) : _objectSpreadProps(_objectSpread({}, item), {
            text: (0,_i18n__WEBPACK_IMPORTED_MODULE_2__.t)(item.text)
        });
    });
};


/***/ }),

/***/ 401192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useLoyaltyMemberInfo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(859676);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(423942);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(420577);
/* harmony import */ var contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var contexts_ServiceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(643015);
/* harmony import */ var contexts_LoyaltyProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(261105);







const useLoyaltyMemberInfo = (triggerFetching)=>{
    const { needToCheckLoyaltyMemberId , notFetchLoyaltyMemberInfoGlobally  } = (0,contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { user  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    const { loyaltyBFFService  } = (0,contexts_ServiceContext__WEBPACK_IMPORTED_MODULE_5__/* .useServices */ .Su)();
    const { loyaltyMemberInfo: loyaltyMemberInfoCtx , loading: loadingCtx , setTriggerGetMemberInfo ,  } = (0,contexts_LoyaltyProvider__WEBPACK_IMPORTED_MODULE_6__/* .useLoyalty */ .m)();
    const hasFetchedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const shouldFetchLoyaltyInfo = !!needToCheckLoyaltyMemberId ? (user === null || user === void 0 ? void 0 : user.telephone) && (user === null || user === void 0 ? void 0 : user.loyaltyMemberId) : user === null || user === void 0 ? void 0 : user.telephone;
    const { data: loyaltyMemberInfo , isValidating , mutate ,  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(shouldFetchLoyaltyInfo ? [
        "/member",
        user === null || user === void 0 ? void 0 : user.telephone
    ] : null, async ()=>{
        try {
            const loyaltyClientId = loyaltyBFFService.getClientId();
            if (loyaltyClientId) {
                return await loyaltyBFFService.getLoyaltyMemberInfo();
            }
        } catch (e) {
            _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(e, "Error fetching loyalty member info");
            return undefined;
        }
    }, {
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateIfStale: false,
        shouldRetryOnError: false
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        // only call API If have no data (!loyaltyMemberInfo)
        // AND not fetching data (!isValidating)
        // AND triggerFetching is true (triggerFetching is passed from the component)
        // AND hasFetchedRef is false (to prevent multiple calls)
        if (notFetchLoyaltyMemberInfoGlobally && !!(user === null || user === void 0 ? void 0 : user.telephone) && !hasFetchedRef.current && !loyaltyMemberInfo && !isValidating && !!triggerFetching) {
            hasFetchedRef.current = true;
            mutate();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user === null || user === void 0 ? void 0 : user.telephone
    ]);
    const refetchLoyaltyMemberInfo = ()=>{
        if (notFetchLoyaltyMemberInfoGlobally) {
            mutate();
        } else {
            setTriggerGetMemberInfo((prev)=>!prev);
        }
    };
    return {
        loyaltyMemberInfo: notFetchLoyaltyMemberInfoGlobally ? loyaltyMemberInfo : loyaltyMemberInfoCtx,
        loading: notFetchLoyaltyMemberInfoGlobally ? isValidating : loadingCtx,
        refetchLoyaltyMemberInfo
    };
};


/***/ }),

/***/ 316763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ NotificationList; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(179185);
// EXTERNAL MODULE: ../../packages/utils/dist/html.es.js
var html_es = __webpack_require__(531439);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ../../.yarn/cache/dompurify-npm-2.3.6-0bc101c0e7-4b2bbf6bc6.zip/node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(391547);
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);
;// CONCATENATED MODULE: ./modules/notification/components/NotificationItem.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin-right: 16px;\n  width: 64px;\n  height: 64px;\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: unset;\n  border-radius: 50%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: calc(100% - 80px);\n  .message {\n    font-size: 14px;\n    color: #848788;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    line-height: 18px;\n    margin-top: 4px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #434657;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  color: #82869e;\n  line-height: 16px;\n  min-width: fit-content;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  color: #82869e;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-height: 20px;\n  margin-top: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







const NotificationItem = (props)=>{
    const { epicOmni948 , logo  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const date = props.time ? new Date(props.time) : new Date();
    const formatDate = "".concat(date.getDate(), "/").concat(date.getMonth() + 1, " - ").concat(date.getHours(), ":").concat(date.getMinutes());
    const avatarImgPath = (0,react.useMemo)(()=>{
        return epicOmni948 ? props.avatar || logo.full.path || "" : props.avatar || "";
    }, [
        epicOmni948,
        props.avatar,
        logo.full.path
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({
        isRead: props.isRead
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                children: !!avatarImgPath && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                        src: avatarImgPath,
                        alt: "",
                        borderRadius: 50,
                        contain: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWrapper, {
                                children: props.title
                            }),
                            props.time && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeWrapper, {
                                children: formatDate
                            })
                        ]
                    }),
                    props.message.includes("\n") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: props.message.split("\n").map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MessageWrapper, {
                                dangerouslySetInnerHTML: {
                                    __html: purify_default().sanitize((0,html_es/* htmlDecode */.l)(item))
                                }
                            }, "".concat(item, "-").concat(index)))
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageWrapper, {
                        dangerouslySetInnerHTML: {
                            __html: purify_default().sanitize((0,html_es/* htmlDecode */.l)(props.message))
                        }
                    })
                ]
            })
        ]
    }));
};
const borderColor = "#e0e0e0";
const Wrapper = emotion_styled_browser_esm["default"].div((param)=>{
    let { isRead  } = param;
    return "\n  padding: 16px;\n  display: flex;\n  cursor: pointer;\n  border-bottom: 1px solid ".concat(borderColor, ";\n  background-color: ").concat(isRead ? "white" : "rgb(255, 242, 242)", ";\n");
});
const Avatar = emotion_styled_browser_esm["default"].div(_templateObject(), borderColor);
const ProductImageWrapper = emotion_styled_browser_esm["default"].div(_templateObject1());
const ContentWrapper = emotion_styled_browser_esm["default"].div(_templateObject2());
const HeaderWrapper = emotion_styled_browser_esm["default"].div(_templateObject3());
const TitleWrapper = emotion_styled_browser_esm["default"].span(_templateObject4());
const TimeWrapper = emotion_styled_browser_esm["default"].span(_templateObject5());
const MessageWrapper = emotion_styled_browser_esm["default"].span(_templateObject6());

;// CONCATENATED MODULE: ./modules/notification/components/NotificationList.tsx
function NotificationList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NotificationList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NotificationList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



const NotificationList = (param)=>{
    let { notifications , onNotificationClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: notifications.map((notification)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationItem, NotificationList_objectSpread({
                title: notification.title,
                message: notification.message,
                isRead: notification.is_read,
                onClick: ()=>onNotificationClick(notification),
                time: notification.created_at,
                avatar: !notification.order ? notification.image_url : notification.order.imageUrl
            }, (0,helper_es/* getTrackingData */.O5)({
                isTrackContent: true,
                contentName: "notification",
                regionName: "notificationList",
                index: notification.id,
                payload: JSON.stringify({
                    msg_id: notification.id.toString(),
                    trace_id: notification.trace_id
                })
            })), notification.id))
    });
};


/***/ }),

/***/ 730492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ desktop_notification; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./components/Loading.tsx
var Loading = __webpack_require__(235904);
// EXTERNAL MODULE: ./components/Layout/AccountLayout.tsx
var AccountLayout = __webpack_require__(429491);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/EmptyState/EmptyState.es.js + 1 modules
var EmptyState_es = __webpack_require__(791990);
// EXTERNAL MODULE: ./modules/notification/NotificationProvider.tsx
var NotificationProvider = __webpack_require__(397338);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Card/Card.es.js
var Card_es = __webpack_require__(319326);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../packages/types/dist/ds/index.es.js + 3 modules
var ds_index_es = __webpack_require__(285212);
// EXTERNAL MODULE: ./modules/notification/components/NotificationList.tsx + 1 modules
var NotificationList = __webpack_require__(316763);
// EXTERNAL MODULE: ./modules/notification/helper.ts
var helper = __webpack_require__(907276);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./constants/nav-items.tsx
var nav_items = __webpack_require__(193275);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(423942);
;// CONCATENATED MODULE: ./modules/notification/desktop/Notification.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 2rem;\n  text-align: center;\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}















const NotificationPage = ()=>{
    const { notifications , checkpoint , loading , getNotifications , markReadNotification , status , markReadAll ,  } = (0,NotificationProvider/* useNotification */.lm)();
    const router = (0,next_router.useRouter)();
    const { epicOmni948  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { user , authService  } = (0,context_es/* useAuth */.aC)();
    const getTitleByNotiType = ()=>{
        var ref;
        if (((ref = router.query) === null || ref === void 0 ? void 0 : ref.type) === "orders") {
            return (0,i18n.t)("Cập nhật đơn h\xe0ng");
        }
        return (0,i18n.t)("Th\xf4ng b\xe1o của bạn");
    };
    (0,react.useEffect)(()=>{
        // redirect users to login page if they access order notification page when not login yet
        if (epicOmni948 && router.asPath.includes(nav_items/* SHARED_NAV_ITEMS_HREFS.ORDERS_NOTI */.yh.ORDERS_NOTI) && !(user === null || user === void 0 ? void 0 : user.userId)) {
            authService.login(window.location.href);
        }
    }, [
        router.asPath,
        epicOmni948,
        user === null || user === void 0 ? void 0 : user.userId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {
        isLoading: loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccountLayout/* AccountLayout */.p, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                    justify: "space-between",
                    marginBottom: "s12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Title */.Dx, {
                            children: getTitleByNotiType()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                            variant: "link",
                            color: "secondary",
                            padding: "s0",
                            onClick: ()=>markReadAll((0,helper/* getExternalTypesByPath */.KX)(router.query)),
                            children: (0,i18n.t)("Đ\xe1nh dấu tất cả đ\xe3 đọc")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                    children: status === NotificationProvider/* PageStatus.EMPTY */.ti.EMPTY && !loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CenteredWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState_es/* EmptyState */.u, {
                            text: (0,i18n.t)("Bạn chưa c\xf3 th\xf4ng b\xe1o mới")
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationList/* NotificationList */.x, {
                                notifications: notifications,
                                onNotificationClick: async (noti)=>{
                                    await markReadNotification(noti);
                                    (0,helper/* onNotificationClick */.hC)(noti, router);
                                }
                            }),
                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                                children: (0,i18n.t)("Đang tải th\xeam...")
                            }),
                            !loading && !checkpoint && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                                children: (0,i18n.t)("Đ\xe3 hết th\xf4ng b\xe1o!")
                            }),
                            !loading && !!checkpoint ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                    variant: "secondary",
                                    size: ds_index_es/* SizeEnum.s */.mO.s,
                                    onClick: ()=>getNotifications(checkpoint),
                                    children: (0,i18n.t)("Tải th\xeam")
                                })
                            }) : null
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Notification = (NotificationPage);
const Message = emotion_styled_browser_esm["default"].div((param)=>{
    let { theme  } = param;
    return "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 0.75rem 0;\n  text-align: center;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.textSecondary, ";\n");
});
const CenteredWrapper = emotion_styled_browser_esm["default"].div(_templateObject());

;// CONCATENATED MODULE: ./tenants/_template/desktop/notification.tsx

/* harmony default export */ var notification = (Notification);

;// CONCATENATED MODULE: ./pages/default/desktop/notification.tsx
// AUTO GENERATED FILE. DO NOT EDIT.

/* harmony default export */ var desktop_notification = (notification);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4545,10433,93712,49774,92888,40179], function() { return __webpack_exec__(433778); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);